import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const STORY_IMG = "https://static.prod-images.emergentagent.com/jobs/03845479-68ae-49c1-b5ac-681381ff3f15/images/a81efadf7b94e574ebe2af0ddc427ebd40201dff2065d97e1e1802ac75aff06e.jpeg";

export default function BrandStory() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [-60, 60]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);

  return (
    <section id="despre" ref={ref} data-testid="brand-story-section" className="relative py-24 lg:py-36 bg-beige/60 border-y border-line/50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 lg:col-start-1">
          <div className="relative aspect-[4/5] overflow-hidden">
            <motion.img
              style={{ y: imgY, scale }}
              src={STORY_IMG}
              alt="Atmosferă ORÉLIE"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-mocha/20" />
          </div>
        </div>

        <div className="lg:col-span-6">
          <Reveal>
            <p className="eyebrow text-mocha-dark mb-3">Filozofia noastră</p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.08]">
              Descoperă esența ta.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-ink-soft text-lg leading-relaxed mt-6 max-w-xl">
              ORÉLIE este o invitație într-o călătorie senzorială desăvârșită. Fiecare flacon păstrează o poveste creată din esențe rare de trandafir de Taif, ambră caldă, lemn de agar și vanilie de Madagascar.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="text-ink-soft leading-relaxed mt-5 max-w-xl">
              Lucrăm cu migală pentru cei care apreciază rafinamentul absolut, un parfum nu este un simplu accesoriu, ci o extensie a individualității, a emoției și a măiestriei artizanale.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="flex gap-12 mt-12">
              {[["12+", "Ani de măiestrie"], ["100%", "Ingrediente rare"], ["48", "Creații unice"]].map(([n, l]) => (
                <div key={l}>
                  <p className="font-serif text-4xl text-ink">{n}</p>
                  <p className="eyebrow text-[0.6rem] mt-2">{l}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
